<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control is-expanded" >
          <label class="label">Attachments</label>
        </p>
        <p class="control">
          <label class="label">Credit limit</label>
          <input class="input" type="text" name="limit" id="limit" placeholder="Limit" v-model="agency.limit">
        </p>
        <p class="control">
          <label class="label">Current Limit</label>
          <input class="input" type="text" name="current_limit" id="current_limit" v-model="agency.current_limit" disabled>
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Dead Line Start</label>
              <select class="select is-fullwidth" v-model="agency.deadline_start" name="deadline_start" id="deadline_start">
                <option value="0">None</option>
                <option value="10">10</option> 
                <option value="13">13</option>
              </select>
            </p>
            <p class="control is-expanded">
              <label class="label">Dead Line End</label>
              <select class="select is-fullwidth" v-model="agency.deadline_end" name="deadline_end" id="deadline_end">
                <option value="20">20</option>
                <option value="25">25</option> 
                <option value="28">28</option>
              </select>
            </p>
          </div>
        </div>
        <p class="control">
          <label class="label">Payment Bank</label>
          <select class="select is-fullwidth" v-model="agency.payment_bank" name="payment_bank" id="payment_bank">
            <option value="1">Itaú</option>
            <option value="2">Santander</option> 
            <option value="3">Confidence</option>
            <option value="4">Base</option> 
            <option value="5">Bank of American</option> 
            <option value="6">Wells</option>
            <option value="7">Cartão de Crédito</option>
          </select>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import babelPolyfill from 'babel-polyfill'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      agency_id: {
        type: Number
      }
    },
    data () {
      return {
        agency: {
          payment_type: 1,
          limit: 0,
          logo: '',
          social_contract: '',
          financial_statement: '',
          billing_report: '',
          serasa: ''
        },
        file: '',
        file1: '',
        file2: '',
        file3: '',
        file4: '',
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      changeLogo () {
        this.agency.logo = ''
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      async save () {
        this.inProgress = true
        this.error = ''
        this.context.$http.post(this.context.$store.state.config.apiURL + '/agencies/payment/' + this.agency_id, this.agency).then((response) => {
          this.inProgress = false
          this.close(false, {ok: true, message: 'The Agency ' + response.body.name + ' was successfully save'})
        }, (response) => {
          this.inProgress = false
          this.error = response.body
        })
        // }
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/agencies/' + this.agency_id).then((response) => {
          this.agency = response.body
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      }
    },
    components: {
      babelPolyfill
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// AgencyFinances.vue?7ff912ce